import {
  CONTRACT_PRODUCT_TYPES,
  CONTRACT_TYPES
} from '../../Views/Contracts/contract_enums';

export const checkConstructorContract = contract => {
  if (!contract) {
    return false;
  }

  return (
    contract.type === CONTRACT_TYPES.Construction &&
    contract.productType === CONTRACT_PRODUCT_TYPES.Generic
  );
};
